/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSelfManagedCluster extends models.ServiceAccountNativeDetailsBaseForKubernetesClusterOthers {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForSelfManagedCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSelfManagedCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSelfManagedCluster>): ServiceAccountNativeDetailsForSelfManagedCluster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSelfManagedCluster(), model);
        ServiceAccountNativeDetailsForSelfManagedCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSelfManagedCluster>): ServiceAccountNativeDetailsForSelfManagedCluster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSelfManagedCluster.newInstance(<ServiceAccountNativeDetailsForSelfManagedCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSelfManagedCluster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSelfManagedCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSelfManagedCluster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSelfManagedCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
